import { put, select, takeLatest } from "redux-saga/effects"
import { Types as LoaderTypes } from "model/graphql"
import { Creators as analyzeExposureCreators } from "modules/analyze-exposure-details/model"
import { chain, get } from "lodash"

function* handleLoadSuccess({ resource, data }) {
  if (resource === "groupedExposureContributors") {
    const { selectedGroup } = yield select(state => ({
      selectedGroup: get(state, "modules.analyzeExposureDetails.selectedGroup"),
    }))

    if (selectedGroup) {
      const selectedGroupExists = chain(data)
        .get("model.simulation.groupedExposureContributors.0.groupedContributors")
        .some(item => item.id === selectedGroup.id)
        .value()

      if (!selectedGroupExists) {
        yield put(analyzeExposureCreators.hideGroup())
      }
    }
  }
}

export function* saga() {
  yield takeLatest(LoaderTypes.LOAD_SUCCESS, handleLoadSuccess)
}
